module.exports = __webpack_public_path__ + "static/img/no_data.1ae703b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/no_data.png
// module id = W+37
// module chunks = 10